import { normTxt } from './beneficiario-plan.util';

export function toSafeNumber(value: unknown, defaultValue = 0): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : defaultValue;
}

export function toBooleanFromSN(value: unknown): boolean {
  const v = normTxt(value);
  return v === 'S' || v === 'SI' || v === 'TRUE' || v === '1';
}

export function normalizeCampaignDate(value: unknown): string {
  const raw = (value ?? '').toString().trim();
  if (!raw || raw.toUpperCase() === 'NULL') return '';

  const ymd = raw.match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})$/);
  if (ymd) return `${ymd[1]}-${ymd[2]}-${ymd[3]}`;

  const dmy = raw.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})$/);
  if (dmy) {
    const [, dd, mm, yyyy] = dmy;
    return `${yyyy}-${mm}-${dd}`;
  }

  if (/^\d{8}$/.test(raw)) {
    if (raw.startsWith('19') || raw.startsWith('20')) {
      return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`;
    }
    return '';
  }

  if (/^\d+$/.test(raw)) return '';

  return raw;
}

export function buildPairKey(cuenta: unknown, subcta: unknown): string {
  const cta = (cuenta ?? '').toString().trim().toUpperCase();
  const sub = (subcta ?? '').toString().trim().toUpperCase();
  return `${sub}|||${cta}`;
}
